<template>
    <MainLayout selectMenu="22-1" >
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>
            <Row class="menu-line" type="flex">
                <Col flex="12" class="menu-actions ">
                </Col>
                <Col flex="12" class="search-part">
                {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange"
                    placement="bottom-end" :placeholder="getTranslation('k220')" style="width: 210px"
                    v-model="selectDate" format="yyyy-MM-dd">
                </DatePicker>&nbsp;
                {{ getTranslation('p055') }}：&nbsp;
                <Select :transfer="true" size="small" v-model="msg_id" :filterable="true"
                    :placeholder="getTranslation('m034')" style="width:150px" @on-change="getData()">
                    <Option v-for="(item, key) in operateTypeMap" :value="item.val" :key="key">{{ item.name }}</Option>
                </Select>&nbsp;
                <Input  size="small" type="text" style="width: 150px"
                    v-model="mac_code" :placeholder="getTranslation('m010')" @on-enter="getData()" />
                <Button type="primary" @click.native="getData()" size="small" shape="circle" icon="ios-search"></Button>
                </Col>
            </Row>
            <Row type="flex">
                <Col flex="1" class="table-container left-fix">
                <Row class="table-header" type="flex">
                    <Col flex="2" class="table-cell">{{ getTranslation('k222') }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ getTranslation('m010') }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ getTranslation('p025') }}
                    </Col>
                    <Col flex="3" class="table-cell">{{ getTranslation('p026') }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ getTranslation('p054') }}（μOhm）
                    </Col>
                    <Col flex="2" class="table-cell">{{ getTranslation('p055') }}
                    </Col>
                    <Col flex="1" class="table-cell">{{ getTranslation('p056') }}
                    </Col>
                </Row>
                <Row v-for="(item, index) in record" :key="item.id"
                    :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
                    <Col flex="2" class="table-cell">{{ item.created_at_string }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ item.mac_code }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ item.program_before }}
                    </Col>
                    <Col flex="3" class="table-cell">{{ item.program_after }}
                    </Col>
                    <Col flex="2" class="table-cell">{{ item.ref_range }}
                    </Col>
                    <Col flex="2" class="table-cell">{{operateTypeMap.find(type => type.val == item.msg_id)?.name}}
                    </Col>
                    <Col flex="1" class="table-cell flex-middle"><Button :type="selectIndex === item.id ? 'warning' : 'success'" size="small" icon="ios-eye-outline" @click="viewDetails(item)"></Button>
                    </Col>
                </Row>
                </Col>
                <Col class="right-fix">
                    <div ref="charts" :style="{ width: chartWidth, height: '500px' }"></div>
                </Col>
            </Row>
            <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
                @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
                :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }} {{ getTranslation('c011') }}
            </Page>
        </div>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { Button,  Row, Col, DatePicker, Select, Option, Page, Input } from 'view-design';
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError, formatUTCDate } from '@/util/util.js'

export default {
    name: 'FixIndex',
    components: {
        MainLayout,
        NoAuth,  Button, Row, Col, DatePicker, Select, Option, Page,Input
    },
    props: {

    },
    data() {
        return {
            hasAuth: true,
            total: 0,
            pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
            current: 1,
            pageSizeAry: PAGE_SIZE_ARY,
            selectDate: [new Date(), new Date()],
            record: [],
            msg_id: -1,
            chartWidth: '100%',
            myChart:null,
            aSeries: [],
            legendSelected: {},
            xAxisData: [],
            isSelecting: false,
            startPos: null,  
            mac_code: '', 
            selectIndex : -1,         

        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        operateTypeMap() {
            return [
                { val: -1, name: this.getTranslation('k236') },
                { val: 1, name: this.getTranslation('p045') },
                { val: 2, name: this.getTranslation('p046') },
                { val: 3, name: this.getTranslation('p062') },
            ]
        },
    },
    watch: {

    },
    created() {
        this.initCharts();
        this.getData();

    },
    mounted() {

    },
    methods: {
        getData() {
            let url = API_URL["fixAlarmGet"];
            let params = {
                page: this.current,
                page_size: this.pageSize,
                start: formatUTCDate(this.selectDate[0]),
                end: formatUTCDate(this.selectDate[1]),
                msg_id: this.msg_id,
                mac_code: this.mac_code,
            }
            this.$store.commit('setQueryDate', this.selectDate)
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code && res.data.code == 200) {
                        this.record = res.data.data && res.data.data.data || [];
                        this.total = res.data.data.total;
                        this.pageSize = res.data.data.pagination.page_size;
                        this.current = res.data.data.pagination.page;
                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.code && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })

        },
        handlePageChange(page) {
            this.current = page;
            this.getData();
        },
        handlePageSizeChange(pageSize) {
            this.current = 1;
            this.pageSize = pageSize;
            localStorage.setItem('user.page_size', this.pageSize)
            this.getData();
        },
        viewDetails(item) {
            this.selectIndex = item.id;
            this.aSeries = [];
            this.xAxisData = [];
            let runningbeforeData = JSON.parse(item.running_res_curve_before);
            let runningafterData = JSON.parse(item.running_res_curve_after);
            let refbeforeData = JSON.parse(item.ref_res_curve_before);
            let refafterData = JSON.parse(item.ref_res_curve_after);
            let refRange = item.ref_range;
            let maxLen = Math.max(runningbeforeData.length, runningafterData.length, refbeforeData.length, refafterData.length);
            for (let i = 0; i < maxLen; i++) {
                this.xAxisData.push(i + 1);
            }
            this.aSeries.push({
                key: "fix-before",
                name: this.getTranslation('p057'),
                type: 'line',
                showSymbol: false,
                lineStyle: { width: 2, color: '#800080' },
                z: 20,
                data: runningbeforeData
            });            
            this.aSeries.push({
                key: "fix-after-avg",
                name: this.getTranslation('p058'),
                type: 'line',
                showSymbol: false,
                lineStyle: { width: 2, color: '#32cd32' },
                z: 20,
                data: runningafterData
            });
            this.aSeries.push({
                key: "fix-before-ref",
                name: this.getTranslation('p038'),
                type: 'line',
                showSymbol: false,
                lineStyle: { width: 2, color: '#6495ed' },
                z: 20,
                data: refbeforeData
            });
            this.aSeries.push({
                key: "fix-after-ref",
                name: this.getTranslation('p039'),
                type: 'line',
                showSymbol: false,
                lineStyle: { width: 2, color: '#ff7f50' },
                z: 20,
                data: refafterData
            });
            
            if (runningbeforeData.length == runningafterData.length && refbeforeData.length == refafterData.length
                && runningbeforeData.length == refbeforeData.length
            ) {
                
                // compute markPoints using the rule: abs(rb - ra - (rfb - rfa)) > refRange
                const anomalies = [];
                let minLen = runningbeforeData.length;
                const range = Number(refRange);
                if (!isNaN(range)) {
                    for (let x = 0; x < minLen; x++) {
                        const rb = Number(runningbeforeData[x]);
                        const ra = Number(runningafterData[x]);
                        const rfb = Number(refbeforeData[x]);
                        const rfa = Number(refafterData[x]);
                        if ([rb, ra, rfb, rfa].some(v => isNaN(v))) continue;
                        const diff = Math.abs(rb - ra - (rfb - rfa));
                        if (diff > range || rb - ra < 0) {
                            // mark on the after series at x+1 (category axis) and y=ra
                            anomalies.push({ coord: [x , rfa], value: 0 });                            
                        }
                    }
                }
                const afterSeries = this.aSeries.find(s => s.key === 'fix-after-avg');
                if (afterSeries && anomalies.length) {
                    afterSeries.markPoint = {
                        data: anomalies,
                        symbol: 'circle',
                        symbolSize: 8,
                        itemStyle: { color: '#e74c3c' },
                        label: { show: false }
                    };
                }
            }

            this.legendSelected[this.getTranslation('p039')] = true;
            this.reChart();
        },
        initCharts() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.charts.offsetWidth-10;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.charts);
                
                this.setBrush();
            })
        },
        setBrush() {
            
            // 确保移除之前的事件监听器
            this.myChart.getZr().off('mousedown');
            //this.myChart.getZr().off('mousemove');
            this.myChart.getZr().off('mouseup');
            this.myChart.getZr().off('dblclick');

            // 绑定事件
            const zr = this.myChart.getZr();

            zr.on('mousedown', (e) => {
                if (e.event.which !== 1) return; // only left button

                // only activate brush inside the grid, ignore clicks on toolbox and elsewhere
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                const gridModel = this.myChart.getModel().getComponent('grid', 0);

                if (gridModel) {
                    const grid = gridModel.coordinateSystem;
                    const rect = grid.getRect();

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: false,
                            shape: {
                                x: this.startPos.x,
                                y: rect.y,
                                width: 0,
                                height: rect.height
                            },
                            style: {
                                fill: 'rgba(150, 150, 150, 0.3)',
                                stroke: '#999',
                                lineWidth: 1,
                            },
                        }
                    });
                }
            });

            zr.on('mousemove', (e) => {
                if (this.isSelecting && this.startPos) {
                    const width = e.offsetX - this.startPos.x;
                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            shape: { width }
                        }
                    });
                }
            });

            zr.on('mouseup', (e) => {
                if (this.isSelecting && this.startPos) {
                    this.isSelecting = false;

                    const endPos = { x: e.offsetX, y: e.offsetY };
                    const width = Math.abs(endPos.x - this.startPos.x);

                    if (width > 10) {
                        this.applyZoom(this.startPos.x, endPos.x);
                    }

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: true
                        }
                    });

                    this.startPos = null;
                }
            });

            zr.on('dblclick', (e) => {
                // only reset zoom when double-click happens inside the grid
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.myChart.dispatchAction({
                    type: 'dataZoom',
                    dataZoomId: 'dataZoomX',
                    start: 0,
                    end: 100
                });
            });
        },

        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);
            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;

            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
        },
        reChart() {
            const legendData = this.aSeries.map(s => s.name);
            const selected = {};
            legendData.forEach(n => {
                // eslint-safe own check
                selected[n] = Object.prototype.hasOwnProperty.call(this.legendSelected, n)
                    ? this.legendSelected[n]
                    : true;
            });
            this.legendSelected = selected;

            this.myChart.setOption({
                xAxis: [{
                    axisLine: { onZero: true },
                    type: 'category',
                    boundaryGap: false,
                    splitLine: { show: true },
                    axisLabel: {
                        formatter: function (value) {
                            const v = parseInt(value, 10);
                            return isNaN(v) ? value : String(v);
                        }
                    },
                    data: this.xAxisData
                }],
                yAxis: [{
                    axisLine: { onZero: true },
                    type: 'value'
                }],
                legend: {
                    data: legendData,
                    selected: this.legendSelected,
                    selectedMode: true
                },
                series: this.aSeries,
                dataZoom: [
                    {
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: 0,
                        show: false,
                        end: 100
                    },
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'line' },
                    formatter: (params) => {
                        let tooltipText = '';
                        if (Array.isArray(params)) {
                            params.forEach(p => {
                                if (p && p.seriesName) {
                                    tooltipText += `${p.seriesName}: ${p.data}<br/>`;
                                }
                            });
                        }
                        return tooltipText;
                    }
                },
            },true);
        },

    }
}
</script>

<style scoped>
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");

.right-fix {
    padding-left: 4px;
    height: calc(100vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
    flex: 0 0 600px;
    /* adjust fixed width as needed */
    max-width: 600px;
}
.left-fix{
    height: calc(100vh - 200px);
    overflow-y: auto;
}
</style>